import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

@Injectable()
export class GroupGuard implements CanActivate {

  constructor(private store: Store, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    const allowedGroups = next.data['roles'] as Array<string>;
    const groups = this.store.snapshot().session.groups;
    const allowed = allowedGroups.some(r => groups.includes(r));
    if(!allowed) this.router.navigate(['']);

    return allowed;
  }
}
